import { createSelector } from '@ngrx/store';

import type { ID } from '@core/ngrx-legacy';
import { createEntityCollectionStore, memoizeSelector } from '@core/ngrx-legacy';

import type { LocationJobsEntity } from './locations-jobs.types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<LocationJobsEntity>()('LocationJobs');

const LocationJobsActions = {
  fetchOne: actions.fetchOne,
  fetchOneSuccess: actions.fetchOneSuccess,
  fetchOneFailed: actions.fetchOneFailed,
};

const LocationJobsSelectors = {
  ...selectors,
  byId: memoizeSelector((id: ID) => createSelector(selectors.byId(id), entity => entity?.jobs)),
};

export {
  LocationJobsActions,
  LocationJobsSelectors,
  namespace as LocationJobsNamespace,
  reducer as LocationJobsReducer,
};
